import {
  AdminSettingEntity,
  CreateUserEntity,
} from '@/pages/privatePages/user/types';
import { BaseService } from './base.service';
import APIService from './axios.service';
import { SignedUrlPayload } from '@/queries/user.query';
import { SignedUrlData, UserEntity } from '@/interfaces';
import { QueryKeysEnum } from '@/enums';
class UserService extends BaseService<'user', UserEntity, CreateUserEntity> {
  constructor() {
    super(QueryKeysEnum.USER);
  }
  getAdminSettings = (): Promise<AdminSettingEntity> => {
    return APIService.get('/admin-setting');
  };

  getSignedUrl = (file: SignedUrlPayload): Promise<SignedUrlData> => {
    return APIService.post(`/admin-setting/get-signed-url`, file);
  };

  storeTermsOfServicePath = (path: string): Promise<any> => {
    return APIService.post('/admin-setting/store-terms-of-service-path', {
      path,
    });
  };

  getPresignedUrl = (path: string): Promise<any> => {
    return APIService.post(
      '/admin-setting/get-presigned-url-for-read-terms-of-service-files',
      { path },
    );
  };
}
export const userService = new UserService();
